import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import includes from 'lodash/includes';
import reject from 'lodash/reject';
import classnames from 'classnames';
import FormInputLabel from './form_input_label.jsx';
import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';
import { CheckCircleIcon, WarningIcon } from 'zoomforth_component_lib/external_modern_icons.jsx';

import {
  checkboxQuestionPropType,
  formValuePropType
} from './prop_types.js';
import { preventEnterKeyDownSubmit } from './form.jsx';

export const FormCheckboxInput_ViewerVersion2 = ({
  formValue,
  question,
  uniqueFormString,
  onQuestionChange
}) => (
  <fieldset id={question.id}>
    <legend>
      <FormInputLabel {...{ question, formValue, uniqueFormString, isFieldsetLabel: true }} />
    </legend>
    <div className="form-input form-option-inputs">
      {map(question.content.options, (option, index) => (
        <div
          className={classnames(
            'form-option-input-container',
            includes(formValue.value, option.label) ? 'form-option-input-selected' : 'form-option-input-deselected'
          )}
          key={`${question.name}-${index}`}
        >
          <span className="form-option-input">
            <input
              aria-describedby={question.isRequired ? null : 'optional-description'}
              id={`${question.name}-${uniqueFormString}-${index}`}
              type="checkbox"
              name={question.name}
              value={option.label}
              onChange={(e) => {
                if (e.target.checked) {
                  onQuestionChange(question, [option.label].concat(formValue.value));
                } else {
                  onQuestionChange(question, reject(formValue.value, (optionLabel) => (optionLabel === option.label)));
                }
              }}
              onKeyDown={preventEnterKeyDownSubmit}
            />
          </span>
          <label htmlFor={`${question.name}-${uniqueFormString}-${index}`} className="form-option-input-label">
            {option.label}
          </label>
        </div>
      ))}
      <span className="form-input-status-icon-container">
        {formValue.error ?
          <WarningIcon className="form-input-status-icon" />
          :
          <CheckCircleIcon className="form-input-status-icon" />
        }

      </span>
    </div>
    <div className="form-input-error">
      <p className="form-input-error-text">Please fill in this field.</p>
    </div>
  </fieldset>
);

FormCheckboxInput_ViewerVersion2.propTypes = {
  formValue: formValuePropType.isRequired,
  question: checkboxQuestionPropType.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionTouch: PropTypes.func.isRequired
};

export const FormCheckboxInput_ViewerVersion1 = ({
  formValue,
  question,
  onQuestionChange
}) => (
  <Fragment>
    <label className="form-field-label">
      {question.label} {question.isRequired && <span className="form-field-required-indicator">*</span>}
    </label>
    {map(question.content.options, (option, index) => (
      <div
        className="form-field-container"
        key={`${question.name}-${index}`}
      >
        <span className="form-field-checkbox-container">
          <input
            id={`${question.name}-${index}`}
            className="form-field-checkbox"
            type="checkbox"
            name={question.name}
            value={option.label}
            onChange={(e) => {
              if (e.target.checked) {
                onQuestionChange(question, [option.label].concat(formValue.value))
              } else {
                onQuestionChange(question, reject(formValue.value, (optionLabel) => (optionLabel === option.label)))
              }
            }}
            onKeyDown={preventEnterKeyDownSubmit}
          />
        </span>
        <label htmlFor={`${question.name}-${index}`} className="form-field-option-label">
          {option.label}
        </label>
      </div>
    ))

    }
  </Fragment>
);

FormCheckboxInput_ViewerVersion1.propTypes = {
  formValue: formValuePropType.isRequired,
  question: checkboxQuestionPropType.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionTouch: PropTypes.func.isRequired
};

const FormCheckboxInput = (props) => (
  <SiteViewerVersionComponentSelector>
    <FormCheckboxInput_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <FormCheckboxInput_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

export default FormCheckboxInput;